import { Swiper, SwiperOptions } from "swiper";

import EffectCoverflow from "./effect-coverflow";

export * from "swiper";

export { EffectCoverflow };

export interface ISwiperXComponentData {}

function getSwiperDefaultOptions(): SwiperOptions {
  return {
    grabCursor: true,
    slidesPerView: "auto",
    touchEventsTarget: "container",
    on: {
      afterInit: function () {
        setTimeout(() => (this as any).update());
      },
    },
  };
}

export class SwiperXComponent {
  public static get $defaultData(): ISwiperXComponentData {
    return {};
  }

  public $data!: ISwiperXComponentData;

  public swiper!: Swiper;

  public get slides(): Element[] {
    return (this.swiper?.slides as any as Element[]) ?? [];
  }

  public init($data: ISwiperXComponentData, options?: SwiperOptions) {
    this.$data = $data;
    const { $el, $refs }: { $el: HTMLElement; $refs: { [name: string]: HTMLElement } } = this.$data as any;
    this.swiper = new Swiper($refs.container ?? $el, Object.assign(getSwiperDefaultOptions(), options ?? {}));
  }
}
